export const CATALOG_PAGINATION_MODES = {
  loadMore: "load_more",
  infiniteScroll: "infinite_scroll",
} as const;
